import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shaixuan",
  "use": "icon-shaixuan-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shaixuan\">\n<rect x=\"24\" width=\"24\" height=\"24\" rx=\"2\" transform=\"rotate(90 24 0)\" fill=\"#F5F7FA\" />\n<path d=\"M6.66569 6.44727H17.3324C17.7006 6.44727 17.9991 6.75041 17.9991 7.12439L17.9992 8.19832C17.9993 8.37797 17.929 8.55026 17.8039 8.67729L13.5276 13.021C13.4026 13.148 13.3323 13.3203 13.3323 13.4999L13.3327 17.3222C13.3327 17.7628 12.9251 18.0861 12.5044 17.9792L11.171 17.6406C10.8742 17.5652 10.666 17.2943 10.666 16.9836L10.6657 13.4999C10.6657 13.3203 10.5954 13.148 10.4704 13.021L6.19428 8.67724C6.06926 8.55025 5.99902 8.37799 5.99902 8.19839V7.12448C5.99902 6.75047 6.2975 6.44727 6.66569 6.44727Z\" stroke=\"#A1A5AD\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shaixuan.svg
// module id = oJh3
// module chunks = 45